import { logEvent } from './logGaEvent'

const logOverFilter = () => {
  const attributes = {
    type: 'filter_results_not_found',
    page_name: 'listings',
    product_name: 'air',
  }
  logEvent('display', attributes)
}

export { logOverFilter }
